import PropTypes from "prop-types"
import React, { useContext, useEffect, useRef, useState } from "react"
import UsersFilter from "~/components/Users/UsersFilter"
import UsersTableNext from "~/components/Users/UsersTableNext"
import AppContext from "~/contexts/App"
import UsersContext from "~/contexts/Users"
import Page from "~/pages/Page"

import Box from "../../../../components/Common/Box"
import useStyles from "./styles"

const User = ({ routes = [], ...rest }) => {
  const tableRef = useRef()

  const [totalNumber, setTotalNumber] = useState(null)
  const [totalShowing, setTotalShowing] = useState(null)
  const [accordionExpanded, setAccordionExpanded] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)

  const {
    searchValue,
    setSearchValue,
    activeValue,
    debouncedSliderValue,
    clientValue,
    userTypeValue,
    accountCreationValue,
  } = useContext(UsersContext)
  const { setPageSubTitle, setPageTitle, openSnackBar, openDialog } =
    useContext(AppContext)

  const classes = useStyles()

  useEffect(() => {
    setPageTitle("Users")
    totalNumber && setPageSubTitle(`${totalNumber}`)
  }, [totalNumber])

  //call the api for new data when searchValue and activeValue changes
  useEffect(() => {
    if (debouncedSliderValue[1] !== null) {
      tableRef.current && tableRef.current.onQueryChange()
    }
  }, [
    accountCreationValue,
    searchValue,
    activeValue,
    clientValue,
    userTypeValue,
    debouncedSliderValue[0],
    debouncedSliderValue[1],
  ])

  const sizeDecider = () => {
    if (accordionExpanded) {
      return (
        <Box className={classes.leftContainerExpanded}>
          <UsersFilter
            totalNumber={totalNumber}
            totalShowing={totalShowing}
            setAccordionExpanded={setAccordionExpanded}
            accordionExpanded={accordionExpanded}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </Box>
      )
    } else {
      return (
        <Box className={classes.leftContainer}>
          <UsersFilter
            totalNumber={totalNumber}
            totalShowing={totalShowing}
            setAccordionExpanded={setAccordionExpanded}
            accordionExpanded={accordionExpanded}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </Box>
      )
    }
  }

  return (
    <Page>
      <Box className={classes.usersListContainer} height="100%">
        {sizeDecider()}
        <Box className={classes.rightContainer} height="100%">
          <UsersTableNext
            setTotalNumber={setTotalNumber}
            setTotalShowing={setTotalShowing}
            tableRef={tableRef}
            classes={classes}
            height={100}
            currentPage={currentPage}
            accordionExpanded={accordionExpanded}
            setCurrentPage={setCurrentPage}
          />
        </Box>
      </Box>
      {/* <Router routes={routes} {...rest} /> */}
    </Page>
  )
}
User.propTypes = {
  routes: PropTypes.array,
}
export default User
